<!--
* @FileDescription: 管理后台侧边栏
* @Author: Rocky
* @Date: 2020-12-25
* @LastEditors: Rocky
* @LastEditTime: 2020-12-25
-->
<template>
  <div id="app-aside">
    <div class="app-aside-control">
      <i :class="controlIcon" @click="toggleAside">{{ controlText }}</i>
    </div>
    <el-menu :default-active="currentIndex" :collapse="controlCollapse">
      <template v-for="(item, i) in sidebarItems">
        <span v-if="item.title" class="app-aside-title" :key="i">{{ item.text }}</span>
        <el-submenu v-if="item.trees && item.trees.length > 0" :index="item.index" :key="i">
          <template slot="title"><i :class="item.icon"></i><span>{{ item.text }}</span></template>
          <el-menu-item-group>
            <el-menu-item v-for="subitem in item.trees" :key="subitem.index" :index="subitem.index"
            :data-path="subitem.path" @click="goMain">{{ subitem.text }}</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-menu-item v-if="item.trees && item.trees.length <= 0" :data-path="item.path" @click="goMain" :index="item.index" :key="i">
          <i :class="item.icon"></i><span>{{ item.text }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: 'app-aside',
  data () {
    return {
      controlIcon: 'el-icon-caret-left', // 右箭头 / 左箭头
      controlText: '收起', // 展开 / 收起
      controlCollapse: false, // 侧边栏展开状态
      currentIndex: '1', // 当前高亮 index
      sidebarItems: [
        { index: '1', path: '/', text: '数据统计', icon: 'el-icon-s-data', trees: [] },
        { title: true, text: '商城管理' },
        { index: '2', path: '/settings', text: '客服配置', icon: 'el-icon-s-operation', trees: [] },
        { index: '4', path: '/categories', text: '分类管理', icon: 'el-icon-s-grid', trees: [] },
        { index: '3', path: '/sliders', text: '幻灯片', icon: 'el-icon-picture', trees: [] },
        // { index: '5', path: '/brands', text: '品牌', icon: 'el-icon-s-flag', trees: [] },
        // { index: '6', path: '/countries', text: '原产国信息', icon: 'el-icon-info', trees: [] },
        { title: true, text: '活动优惠' },
        // { index: '14', path: '/special', text: '每日秒杀', icon: 'el-icon-star-on', trees: [] },
        { index: '13', path: '/activity', text: '专场活动', icon: 'el-icon-present', trees: [] },
        { index: '16', path: '/voucher', text: '优惠券', icon: 'el-icon-discount', trees: [] },
        { title: true, text: '店铺' },
        { index: '30', path: '/merchant', text: '商家入驻', icon: 'el-icon-office-building', trees: [] },
        { index: '31', path: '/merchantIntention', text: '商家意向', icon: 'el-icon-collection', trees: [] },
        { title: true, text: '商品' },
        { index: '7', path: '/goods', text: '商品管理', icon: 'el-icon-s-goods', trees: [] },
        { index: '8', path: '/records', text: '备案信息', icon: 'el-icon-s-ticket', trees: [] },
        // { index: '9', path: '/warehouses', text: '仓库配置', icon: 'el-icon-s-home', trees: [] },
        { index: '15', path: '/group', text: '组合管理', icon: 'el-icon-menu', trees: [] },
        { title: true, text: '订单' },
        {
          index: '10',
          path: '#',
          text: '订单管理',
          icon: 'el-icon-s-order',
          trees: [
            { index: '10-4', path: '/ordersPayment', text: '待申报' },
            { index: '10-5', path: '/ordersCart', text: '待清关' },
            { index: '10-6', path: '/ordersFinish', text: '已清关' },
            { index: '10-7', path: '/ordersFail', text: '清关失败' },
            { index: '10-8', path: '/OrdersWaitingCross', text: '待发货-跨境' },
            { index: '10-1', path: '/ordersWaiting', text: '待发货-自营' },
            { index: '10-2', path: '/ordersSend', text: '已发货' },
            { index: '10-3', path: '/ordersAll', text: '全部订单' }
          ]
        },
        { title: true, text: '拼团' },
        {
          index: '16',
          path: '#',
          text: '订单管理',
          icon: 'el-icon-document',
          trees: [
            { index: '16-4', path: '/pinOrdersPayment', text: '待申报' },
            { index: '16-5', path: '/pinOrdersCart', text: '待清关' },
            { index: '16-6', path: '/pinOrdersFinish', text: '已清关' },
            { index: '16-7', path: '/pinOrdersFail', text: '清关失败' },
            { index: '16-8', path: '/pinOrdersFailure', text: '拼团失败' },
            { index: '16-1', path: '/pinOrdersWaiting', text: '待发货' },
            { index: '16-2', path: '/pinOrdersSend', text: '已发货' },
            { index: '16-3', path: '/pinOrdersAll', text: '全部订单' }
          ]
        },
        { title: true, text: '用户' },
        { index: '11', path: '/users', text: '用户管理', icon: 'el-icon-user-solid', trees: [] },
        {
          index: '12',
          path: '#',
          text: '售后',
          icon: 'el-icon-phone',
          trees: [
            { index: '12-1', path: '/serviceInit', text: '待处理' },
            { index: '12-2', path: '/serviceWaiting', text: '待邮寄' },
            { index: '12-3', path: '/serviceSend', text: '已邮寄' },
            { index: '12-4', path: '/serviceFinish', text: '已完成' },
            { index: '12-5', path: '/serviceReject', text: '已驳回' }
          ]
        }
      ]
    }
  },
  methods: {
    /**
     * 通过路由检查当前高亮链接
     */
    highlightSidebar () {
      let that = this
      let currentLocation = window.location.href.split('#')[1]
      let highlightIndex = '1'
      for (let i = 0; i < that.sidebarItems.length; i++) {
        const lv1 = that.sidebarItems[i]
        if (lv1.path && lv1.path === currentLocation) highlightIndex = lv1.index
        if (lv1.trees) {
          for (let j = 0; j < lv1.trees.length; j++) {
            const lv2 = lv1.trees[j]
            if (lv2.path === currentLocation) highlightIndex = lv2.index
          }
        }
      }
      that.currentIndex = highlightIndex
    },
    /**
     * 跳转到 Main 中对应链接
     */
    goMain (e) {
      let that = this
      let linkPath = e.$el.dataset.path
      if (linkPath !== this.$route.path) {
        that.$router.replace({
          path: e.$el.dataset.path,
          params: {}
        })
      }
    },
    /**
     * 收展侧边栏
     */
    toggleAside () {
      let that = this
      that.controlCollapse = !that.controlCollapse
      that.controlText = that.controlCollapse ? '' : '收起'
      that.controlIcon = that.controlCollapse ? 'el-icon-caret-right' : 'el-icon-caret-left'
      that.$emit('toggleAside', that.controlCollapse)
    }
  },
  mounted () {
    this.highlightSidebar()
  }
}
</script>

<style>
.el-menu {
  background-color: #f1f1f1;
}
.el-submenu__title,
.el-menu-item {
  font-size: 12px;
  height: 50px;
  line-height: 50px;
}
.el-submenu__title:hover,
.el-menu-item:focus, .el-menu-item:hover,
.el-menu-item:hover i,
.el-menu-item.is-active {
  color: #626c79;
  background-color: #fafafa;
}
.app-aside-control > i {
  font-size: 11px;
  font-weight: bold;
  padding: 10px;
  color: #bebebe;
  cursor: pointer;
}
.app-aside-control > i:hover {
  color: #343A40;
}
.app-aside-title {
  padding-left: 10px;
  margin: 8px 0;
  display: block;
  color: #454545;
}
</style>



// WEBPACK FOOTER //
// src/components/frame/Aside.vue